<ul class="lobby_group--filter-tabs-ul clearfix slot-games-tabs-ul" [ngClass]="{'lobby_pills_group_scroll_h': !fromNav}" id="lobby_pills_group" *ngIf="!isGameGroupPageActive">
    <li *ngIf="skeltonLoader" class="skelton-loader animated-background"></li>

 
    <ng-container *ngIf="(lobbyDetails && lobbyDetails.length && !homePage) || (lobbyDetails && lobbyDetails.length && homePage && windowType=='mobile')">
        <ng-container *ngFor="let game of lobbyDetails">
            <li *ngIf="game.name !== 'seo_content_tabs' && game.multilingualUrlLobby && game.multilingualUrlLobby[utils.getActualMappedLanguage(langCode)] !== langCode && !skeltonLoader"  
                [ngClass]="{'active': activeLobby === game.id}">
                <a routerLink="{{'/'+langCode+'/casino/'+game.multilingualUrlLobby[utils.getActualMappedLanguage(langCode)]}}" (click)="setActiveLobby(game.id)" id="{{game.multilingualUrlLobby[utils.getActualMappedLanguage(langCode)]}}">
                    <span class="icon-item">
                        <img class="unactive" width="21px" height="21px" src="{{siteUrlPath}}/{{mediaUrlPath}}/menu_icons/lobby_{{game.id}}.svg" />
                        <img class="active" width="21px" height="21px" src="{{siteUrlPath}}/{{mediaUrlPath}}/menu_icons/lobby_{{game.id}}_active.svg" />
                </span>
                    <span class="dropdown-section--listItemText">{{game.name}}</span>
                </a>
            </li>
        </ng-container>
    </ng-container>

    <ng-container *ngIf="homeLobbies && homeLobbies.length && homePage && windowType=='desktop'">
        <ng-container *ngFor="let game of homeLobbies">
            <li  *ngIf="game.name !== 'seo_content_tabs' && game.multilingualUrlLobby[utils.getActualMappedLanguage(langCode)] !== langCode && !skeltonLoader"  
                [ngClass]="{'active': activeLobby === game.id}">
                <a routerLink="{{'/'+langCode+'/casino/'+game.multilingualUrlLobby[utils.getActualMappedLanguage(langCode)]}}" (click)="setActiveLobby(game.id)" id="{{game.multilingualUrlLobby[utils.getActualMappedLanguage(langCode)]}}">
                    <img width="25px" height="25px" src="{{siteUrlPath}}/{{mediaUrlPath}}/menu_icons/lobby_{{game.id}}.png" />
                    <span class="dropdown-section--listItemText">{{game.name}}</span>
                </a>
            </li>
        </ng-container>
    </ng-container>
    <li *ngIf="!skeltonLoader && (!homePage || windowType=='mobile')"
        [ngClass]="{'active': activeLobby === 'allgames'}">
        <a routerLink="{{'/'+langCode+'/casino/allgames'}}" (click)="setActiveLobby('allgames')" id="allgames">
            <span class="icon-item">
            <img class="unactive" width="21px" height="21px" src="{{siteUrlPath}}/{{mediaUrlPath}}/menu_icons/lobby_allgames.svg" />
            <img class="active" width="21px" height="21px" src="{{siteUrlPath}}/{{mediaUrlPath}}/menu_icons/lobby_allgames_active.svg" />
            </span>
            <span class="dropdown-section--listItemText">{{'gamingComp.gaming16' | translate}}</span>
        </a>
    </li>
</ul>
<div *ngIf="isGameGroupPageActive" class="game-group">
    <div class="game-group__name">
        <div class="game-group--wrapper">
            <div class="game-group__name--backicn" (click)="goBack()">
                <i class="icon icon-arrow-2"></i>
            </div>
            <div class="game-group__name--text">
                <span>{{ activeGameGroupName }}</span>
            </div> 
        </div>
        <app-lobby-sorting></app-lobby-sorting>       
    </div>
</div>